import stbAPIGateway from '../../../../services/stbAPIGateway';

export const fetchClientExcursionManagementVendorsList = async ({ rootGetters, commit }) => {
  const axios = rootGetters['app/stbAxios'];

  const stbApi = stbAPIGateway(axios, process.env.API_URL);
  const response = await stbApi.getClientExcursionManagementVendorsList();
  if (response.data) {
    commit('setClientExcursionManagementVendorsList', response.data);
  }
  return response;
};
